import { render, staticRenderFns } from "./umeng-config-add-or-update.vue?vue&type=template&id=b6e0b812"
import script from "./umeng-config-add-or-update.vue?vue&type=script&lang=js"
export * from "./umeng-config-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports